module.exports = __webpack_public_path__ + "media/country_flags/ga-6ef196de.png";